import { SubscriptionBasedComponent } from '../subscription-helpers/subscription-based.component';
import { OnInit, Component } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { LoadingService } from '../services/loading.service';
import { User } from '../model/user';
import * as globals from '../../globals/globals';
import UserHelper from '../helpers/user-helper';
import { Router, NavigationEnd } from '@angular/router';
import { ModalService } from '../services/modal.service';
import { PlanningDateService } from '../services/planning-date-service';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
} from '@angular/material/core';
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { RouteEventsService } from '../services/route-events-service';
import { ConnectionStatusService } from '../services/connection-status.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { FileHelper } from '../helpers/file-helper';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'dd DD/MM',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'placer-navbar',
  templateUrl: './placer-navbar.component.html',
  styleUrls: ['./placer-navbar.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class PlacerNavbarComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  user: User;
  date: Date;

  overview: boolean = true;

  connectedToBackend: boolean = true;

  previousRouteUrl: string;

  showImmoSubProjectSearch: boolean = false;
  isImage = FileHelper.isImage;

  constructor(
    public loadingService: LoadingService,
    private authService: AuthService,
    private modalService: ModalService,
    private planningDateService: PlanningDateService,
    private connectionStatusService: ConnectionStatusService,
    private router: Router,
    private routeEventsService: RouteEventsService
  ) {
    super();
  }

  ngOnInit() {
    this.previousRouteUrl = this.routeEventsService.previousRoutePath.value;
    const installer = this.previousRouteUrl.includes('/installateur/');
    const ipInstaller = this.previousRouteUrl.includes('/ip-installateur/');
    this.showImmoSubProjectSearch =
      this.router.url.includes('/ip-installateur') &&
      !this.router.url.includes('/ip-installateur/');
    this.overview = !(installer || ipInstaller);
    if (installer) {
      this.previousRouteUrl = '/installateur';
    } else if (ipInstaller) {
      this.previousRouteUrl = '/ip-installateur';
    }
    this.addSubscription(this.router.events, (event: any) => {
      if (event.routerEvent) {
        event = event.routerEvent;
      }
      if (event instanceof NavigationEnd) {
        this.previousRouteUrl = event.url;
        const url = event.url;
        const installer = url.includes('/installateur/');
        const ipInstaller = url.includes('/ip-installateur/');
        this.showImmoSubProjectSearch =
          url.includes('/ip-installateur') &&
          !url.includes('/ip-installateur/');
        this.overview = !(installer || ipInstaller);
        if (installer) {
          this.previousRouteUrl = '/installateur';
        } else if (ipInstaller) {
          this.previousRouteUrl = '/ip-installateur';
        }
      }
    });
    this.addSubscription(
      this.authService.getAuthenticatedUserSubscribable(),
      (user) => {
        this.user = user;
      }
    );
    this.addSubscription(
      this.planningDateService.getSelectedPlanningDateSubscribable(),
      (date) => {
        this.date = date;
      }
    );
    this.addSubscription(
      this.connectionStatusService.getConnectionStatusSubject(),
      (online) => {
        this.connectedToBackend = online;
      }
    );
  }

  dateChange(date: Date) {
    this.planningDateService.setSelectedPlanningDate(moment(date));
  }

  changeDay(amount: number) {
    this.planningDateService.changeDay(amount);
  }

  getLettres() {
    if (this.user == null) {
      return '';
    }
    return UserHelper.getLettres(this.user);
  }

  isAdmin(): boolean {
    if (this.user == null || _.isEmpty(this.user)) {
      return false;
    }
    return UserHelper.isAdmin(this.user);
  }

  isImpersonating(): boolean {
    return this.authService.isImpersonating();
  }

  public stopImpersonate() {
    this.modalService.confirmDialog(
      'Nabootsing stoppen',
      'Bent u zeker dat u de nabootsing wilt stoppen?',
      (b) => {
        if (b) {
          this.authService.stopImpersonate();
        }
      }
    );
  }

  returnToAdmin() {
    this.modalService.confirmDialog(
      'Keer terug naar adminportaal',
      'Bent u zeker dat u wilt terugkeren naar het adminportaal?',
      (b) => {
        if (b) {
          this.router.navigateByUrl('/projecten');
        }
      }
    );
  }

  isTestEnvironment(): boolean {
    return !globals.production;
  }

  backPressed() {
    this.router.navigateByUrl(this.previousRouteUrl);
  }

  public logout() {
    this.authService.logout();
    this.router.navigateByUrl('/login');
  }
}
